import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        //购物车行数 
        shoprowCount:0,
        // 购物车数量
        shopNum: 0,
        // 购物车
        shopList: [],
        // 新闻发布管理员权限
        isIssue: false,
        // 保存购物车订单单号
        numberOdd: '',
        index: 0
    },
    mutations: {
        changeIndex(state, i) {
            state.index = i
        },
        changeIndexReset(state) {
            state.index = 0
        },
        changeNumberOdd(state, odd) {
            state.numberOdd = odd
        },
        changeShopNum(state, num) {
                state.shopNum += num
        },
        changeShoprowCount(state,num){
            if (num<0)
            state.shoprowCount=state.shoprowCount-1
            else
            state.shoprowCount += num
        },
        shopNumReset(state) {
            state.shopNum = 0,
            state.shoprowCount=0
        },
        shopListAddArr(state, arr) {
            state.shopList = arr
        },
        shopListReset(state) {
            state.shopList = []
        },
        shopListRemove(state, id) {
            for (let i in state.shopList) {
                if (state.shopList[i].ptypeid == id) {
                    state.shopList.splice(i, 1);
                }
            }
        },
        shopListIsShop(state, row) {
            if (state.numberOdd !== "") {
                state.shopList.push(row)
            } else {
                let foodIndex = state.shopList.findIndex(food => food.ptypeid == row.ptypeid);
                if (foodIndex === -1) {
                    state.shopList.push(row)
                } else {
                    let shopList = JSON.parse(JSON.stringify(state.shopList))
                    shopList[foodIndex].qty += row.qty
                    state.shopList = shopList
                }
            }
        },
        shopListEmpty(state) {
            state.shopList = []
        },
        isIssueChange(state, flag) {
            state.isIssue = flag
        }
    },
    actions: {},
    getters: {
        shopList_get: state => state.shopList,
    }
})